// Configure options specific to Vue I18n
export default defineI18nConfig(() => {
  return {
    fallbackLocale: 'en',
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    warnHtmlInMessage: 'off'
  }
})